/* eslint-disable no-console */
import { useCallback, useState } from 'react'
import { message } from 'antd'

import api from 'Services/api'

import adjustReportData from './utils/adjustReportData'

const joinUrl = (base, extra) => {
  if (!extra) return base

  const normalizedBase = base.replace(/\/$/, '')
  const normalizedExtra = extra.replace(/\/$/, '')

  return `${normalizedBase}/${normalizedExtra}/`
}

const useReportData = ({ columns, url, dataPath = null }) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchReportData = useCallback(
    (filtros, urlSuffix) => {
      setIsLoading(true)

      const finalUrl = joinUrl(url, urlSuffix)

      api
        .post(finalUrl, filtros)
        .then((response) => response.data)
        .then((reportData) => {
          if (dataPath) {
            const adjustedData = {
              ...reportData,
              [dataPath]: adjustReportData(columns, reportData[dataPath])
            }
            return adjustedData
          }

          return adjustReportData(columns, reportData)
        })
        .then(setData)
        .catch((error) => {
          console.log(error)
          if (error.response && error.response.status === 403) {
            message.error(
              'Usuário não possui permissão para filtrar relatorio.',
              5
            )
          } else {
            message.error('Erro ao tentar obter os dados do relatório.')
          }
        })
        .finally(() => {
          setIsLoading(false)
        })
    },
    [url, columns]
  )

  const clearReportDataRequest = useCallback(() => {
    setData([])
    setIsLoading(false)
  }, [])

  return {
    reportDataRequest: { data, isLoading },
    fetchReportData,
    clearReportDataRequest
  }
}

export default useReportData
